import React from 'react';
import { FormGroup } from '@material-ui/core';

import {
  SelectBoxGroupControlProps,
  SelectBoxGroupItemValue,
} from './FilterSelectBoxGroupMobile.interface';
import { SelectBoxOptions } from '../SelectBoxGroup/SelectBoxGroup.interface';
import FilterSelectBox from './FilterSelectBox';
import { useStyles } from './FilterSelectBox.styles';

export default function FilterSelectBoxGroupMobile(
  props: SelectBoxGroupControlProps
) {
  const {
    options,
    input,
    isOptionDisabled,
    isOptionLocked,
    numberOffers,
    sendGTMEvent,
  } = props;
  const classes = useStyles();

  const handleSelectBoxChange = (
    checked: boolean,
    option: SelectBoxOptions
  ) => {
    const { value } = option;

    sendGTMEvent && sendGTMEvent(option, checked);

    let newValue: Array<SelectBoxGroupItemValue> = [];

    if (Array.isArray(input.value)) {
      newValue = [...input.value];
    }

    if (checked) {
      newValue.push(value);
    } else {
      newValue.splice(newValue.indexOf(value), 1);
    }

    input.onChange(newValue);
  };

  return (
    <FormGroup className={classes.formGroup}>
      {options.map((option, index) => (
        <FilterSelectBox
          key={index}
          option={option}
          isOptionDisabled={isOptionDisabled}
          isOptionLocked={isOptionLocked}
          numberOffers={numberOffers}
          handleSelectBoxChange={handleSelectBoxChange}
          input={input}
        />
      ))}
    </FormGroup>
  );
}
